/* KRVVY product card: styles, colour galleries, hover zones, quick-view hook. Loaded ONCE per page from layout/theme.liquid (it used to be inlined by every card, ~28KB x cards). */
  (function(){
    if (window.__jhPcInit) return;
    window.__jhPcInit = true;

    /* card styles live in assets/jh-product-card.css (loaded in <head>) */

    /* Open the KRVVY quick-view modal (jhx-quick-view snippet, rendered globally) — the same modal
       the search drawer uses: full-height gallery + thumbnails + colour/size selection. */
    window.__jhPcOpen = function(productUrl){
      var url = (productUrl || '').split('#')[0];
      var m = url.match(/\/products\/([^/?#]+)/);
      var handle = m ? m[1] : '';
      if (handle && window.jhxOpenQV) { window.jhxOpenQV(handle); return; }
      if (url) window.location.href = url;
    };
    window.__jhQvFit = window.__jhQvFit || function(){};

    /* ---------- per-card colour gallery engine ----------
       Each colour swatch carries data-imgs = that colour's ordered image URLs (from
       custom.color_card_images). Selecting a colour loads its set: shows the cover, marks the
       swatch, and rebuilds the hover zones/dots so hovering cycles THAT colour's images. Cards
       with no colour data fall back to the product-image hover on the .jh-pc__img layers. */
    function jhImgs(sw){
      if(!sw) return [];
      var d = sw.getAttribute('data-imgs');
      if(d){ var a = d.split(',').map(function(s){return s.trim();}).filter(Boolean); if(a.length) return a; }
      var o = sw.getAttribute('data-img'); return o ? [o] : [];
    }
    function jhEnsureZones(card){
      var media = card.querySelector('[data-jh-pc-media]'); if(!media) return null;
      var zones = media.querySelector('.jh-pc__zones');
      var dots  = media.querySelector('.jh-pc__dots');
      if(!zones){ zones=document.createElement('div'); zones.className='jh-pc__zones'; zones.setAttribute('aria-hidden','true'); media.appendChild(zones); }
      if(!dots){  dots =document.createElement('div'); dots.className ='jh-pc__dots';  dots.setAttribute('aria-hidden','true');  media.appendChild(dots);  }
      return { zones: zones, dots: dots };
    }
    function jhBuildZones(card, n){
      var zd = jhEnsureZones(card); if(!zd) return;
      if(n <= 1){ zd.zones.innerHTML=''; zd.dots.innerHTML=''; return; }
      var z='', d='';
      for(var i=0;i<n;i++){
        z += '<button type="button" class="jh-pc__zone" data-jh-pc-zone="'+i+'" aria-label="View image '+(i+1)+'" tabindex="-1"></button>';
        d += '<span class="jh-pc__dot'+(i===0?' is-active':'')+'" data-jh-pc-dot="'+i+'"></span>';
      }
      zd.zones.innerHTML=z; zd.dots.innerHTML=d;
    }
    /* Cross-fade the two overlay layers to `src` (preload into the hidden layer, then reveal). */
    function jhCross(card, src){
      if(!src) return;
      var layers = card.querySelectorAll('[data-jh-pc-vimg]'); if(layers.length < 2) return;
      var cur = card.querySelector('[data-jh-pc-vimg].is-shown');
      if(cur && cur.getAttribute('src') === src) return;
      var next = (cur === layers[0]) ? layers[1] : layers[0];
      var reveal = function(){ next.classList.add('is-shown'); if(cur && cur !== next) cur.classList.remove('is-shown'); };
      if(next.getAttribute('src') === src){ reveal(); }
      else { var pre = new Image(); pre.onload = function(){ next.src = src; reveal(); }; pre.onerror = function(){ next.src = src; reveal(); }; pre.src = src; }
    }
    function jhSetDot(card, i){
      card.querySelectorAll('.jh-pc__dot').forEach(function(dt){ dt.classList.toggle('is-active', parseInt(dt.dataset.jhPcDot,10) === i); });
    }
    /* if a colour that lives in the hidden "+N" overflow gets selected, reveal the row so it shows */
    function jhRevealIfOverflow(card, sw){
      if(sw && sw.classList.contains('jh-pc__swatch--of')){ var row=card.querySelector('.jh-pc__swatches'); if(row){ row.classList.add('is-expanded'); var mb=row.querySelector('[data-jh-pc-more]'); if(mb) mb.setAttribute('aria-expanded','true'); } }
    }
    function jhShowColorIdx(card, i){
      var g = card._jhGallery; if(!g || !g.length) return;
      if(i<0) i=0; if(i>=g.length) i=g.length-1;
      jhCross(card, g[i]); jhSetDot(card, i);
    }
    /* Select a colour: mark its swatch, load THAT colour's image set as the active gallery, rebuild
       the hover zones/dots to match, and show its cover. Used by click, filter auto-select, default. */
    function jhSetColorGallery(card, sw){
      card.querySelectorAll('.jh-pc__swatch').forEach(function(x){ x.classList.remove('jh-pc__swatch--sel'); });
      if(sw) sw.classList.add('jh-pc__swatch--sel');
      var g = jhImgs(sw); card._jhGallery = g;
      jhBuildZones(card, g.length);
      if(g.length){ jhCross(card, g[0]); jhSetDot(card, 0); }
      jhRevealIfOverflow(card, sw);
    }

    /* Delegated handlers — work on all .jh-pc cards on the page */
    /* Hover a zone -> colour mode: cycle the selected colour's images; else the product images. */
    document.addEventListener('mouseenter', function(e){
      var zone = e.target.closest && e.target.closest('[data-jh-pc-zone]');
      if (!zone) return;
      var idx = parseInt(zone.dataset.jhPcZone, 10);
      var card = zone.closest('[data-jh-pc]'); if(!card) return;
      if (card._jhGallery && card._jhGallery.length){ jhShowColorIdx(card, idx); return; }
      card.querySelectorAll('.jh-pc__img').forEach(function(img){ img.classList.toggle('is-active', parseInt(img.dataset.jhPcImgIdx,10) === idx); });
      jhSetDot(card, idx);
    }, true);
    document.addEventListener('mouseleave', function(e){
      var media = e.target.closest && e.target.closest('[data-jh-pc-media]');
      if (!media) return;
      var card = media.closest('[data-jh-pc]'); if(!card) return;
      if (card._jhGallery && card._jhGallery.length){ jhShowColorIdx(card, 0); return; }
      media.querySelectorAll('.jh-pc__img').forEach(function(img){ img.classList.toggle('is-active', parseInt(img.dataset.jhPcImgIdx,10) === 0); });
      jhSetDot(card, 0);
    }, true);
    document.addEventListener('click', function(e){
      /* "+N" -> reveal the hidden overflow colour swatches inline (never navigate away) */
      var moreBtn = e.target.closest && e.target.closest('[data-jh-pc-more]');
      if (moreBtn) {
        e.preventDefault(); e.stopPropagation();
        var row = moreBtn.closest('.jh-pc__swatches');
        if (row) { row.classList.add('is-expanded'); moreBtn.setAttribute('aria-expanded', 'true'); }
        return;
      }
      /* quick-view triggers */
      var btn = e.target.closest && (e.target.closest('[data-jh-pc-choose]') || e.target.closest('[data-jh-pc-media-atc]'));
      if (btn) {
        e.preventDefault(); e.stopPropagation();
        var oc = btn.closest('[data-jh-pc]');
        if (oc) window.__jhPcOpen(oc.dataset.productUrl, oc.dataset.productId);
        return;
      }
      /* colour swatch -> switch the card to that colour's image set (no redirect) */
      var sw = e.target.closest && e.target.closest('.jh-pc__swatch');
      if (sw) {
        e.preventDefault();
        var sc = sw.closest('[data-jh-pc]');
        if (sc) jhSetColorGallery(sc, sw);
        return;
      }
      /* anything else on the card -> product page (the hover zones over the image otherwise swallow
         the click). Real controls keep their own behaviour: title/media links, EMI. */
      var card = e.target.closest && e.target.closest('[data-jh-pc]');
      if (!card) return;
      if (e.target.closest('a[href]:not(.jh-pc__swatch), .jh-pc__emi, .jh-pc__emi-btn, [data-snapmint], button[name]')) return;
      var url = card.getAttribute('data-product-url');
      if (url) window.location.href = url;
    });

    /* ---- Collection colour filters -> auto-select the matching swatch on each card ----
       When colour filters are applied, every card that HAS one of the selected colours shows
       that colour's image and marks its swatch selected. When several match, we pick the
       LATEST-selected filter colour (click order tracked in sessionStorage, survives the facet
       reload). No filters selected = cards keep their default colour. */
    var JHPC_REC = 'jhPcColorRecency';
    function jhRec(){ try { return JSON.parse(sessionStorage.getItem(JHPC_REC) || '[]'); } catch(e){ return []; } }
    function jhPushRec(c){ c = String(c||'').trim().toLowerCase(); if(!c) return; var r = jhRec().filter(function(x){ return x !== c; }); r.unshift(c); try { sessionStorage.setItem(JHPC_REC, JSON.stringify(r.slice(0,24))); } catch(e){} }
    function jhIsColorFilter(inp){ if(!inp || (inp.type!=='checkbox' && inp.type!=='radio')) return false; var n=(inp.name||'').toLowerCase(), id=(inp.id||'').toLowerCase(); return n.indexOf('color')>-1||n.indexOf('colour')>-1||id.indexOf('color')>-1||id.indexOf('colour')>-1; }
    /* The visible colour name of a filter input. The checkbox value is often a gid (grouped
       swatch filters), so fall back to the associated label text and strip any "(12)" count. */
    function jhColorOf(inp){
      var v=(inp.value||'').trim();
      if(v && v.indexOf('gid:')<0 && v.indexOf('/')<0 && v.length<=24) return v.toLowerCase();
      var t='';
      try { if(inp.id){ var l=document.querySelector('label[for="'+(window.CSS&&CSS.escape?CSS.escape(inp.id):inp.id)+'"]'); if(l) t=l.textContent; } } catch(e){}
      if(!t){ var lab=inp.closest('label'); if(lab) t=lab.textContent; }
      if(!t){ var pp=inp.parentElement; if(pp) t=pp.textContent; }
      return (t||'').replace(/\s*\(\d[\d,]*\)\s*$/,'').replace(/\s+/g,' ').trim().toLowerCase();
    }
    function jhSelectedColors(){
      var set=[];
      document.querySelectorAll('input:checked').forEach(function(i){ if(jhIsColorFilter(i)){ var c=jhColorOf(i); if(c && set.indexOf(c)<0) set.push(c); } });
      try { new URLSearchParams(location.search).forEach(function(v,k){ if(/colou?r/i.test(k)){ var vv=(v||'').trim().toLowerCase(); if(vv && vv.indexOf('gid:')<0 && set.indexOf(vv)<0) set.push(vv); } }); } catch(e){}
      return set;
    }
    function jhApplyFilterColors(){
      var sel = jhSelectedColors(); if(!sel.length) return;
      var rec = jhRec();
      var ordered = sel.slice().sort(function(a,b){ var ia=rec.indexOf(a), ib=rec.indexOf(b); ia=ia<0?999:ia; ib=ib<0?999:ib; return ia-ib; }); /* latest-selected first */
      document.querySelectorAll('[data-jh-pc]').forEach(function(card){
        var sws = card.querySelectorAll('.jh-pc__swatch'); if(!sws.length) return;
        var byColor = {};
        sws.forEach(function(sw){ var c=(sw.getAttribute('title')||sw.getAttribute('aria-label')||'').trim().toLowerCase(); if(c && !byColor[c]) byColor[c]=sw; });
        for(var i=0;i<ordered.length;i++){ var m=byColor[ordered[i]]; if(m){ if(!m.classList.contains('jh-pc__swatch--sel')) jhSetColorGallery(card, m); break; } }
      });
    }
    /* On load (no filter override) mark the product's default colour, but leave the product's
       OWN images on the card. Swapping in the default variant's image here meant a product whose
       featured image is not a variant image (Breeze Hipster's featured shot is not on any variant)
       could never show it on a card. The colour overlay now only appears once a colour is actually
       chosen — by a swatch click or a colour filter. */
    function jhDefaultSelect(){
      document.querySelectorAll('[data-jh-pc]').forEach(function(card){
        /* The default colour is selected server-side (product-card-jh-v1 adds jh-pc__swatch--sel), and
           its cover IS the featured image already on screen - so only attach the colour's image list
           for hover/swipe. Nothing visible changes at init. */
        var pre = card.querySelector('.jh-pc__swatch--sel');
        if(pre){
          if(!card._jhGallery){ var pg = jhImgs(pre); card._jhGallery = pg; var zc = card.querySelectorAll('.jh-pc__zone').length; if(pg.length !== zc && !(pg.length <= 1 && zc === 0)) jhBuildZones(card, pg.length); }
          return;
        }
        var sws = card.querySelectorAll('.jh-pc__swatch'); if(!sws.length) return;
        var dc = (card.getAttribute('data-jh-pc-default')||'').trim().toLowerCase();
        var pick=null;
        if(dc){ for(var i=0;i<sws.length;i++){ var c=(sws[i].getAttribute('title')||sws[i].getAttribute('aria-label')||'').trim().toLowerCase(); if(c===dc){ pick=sws[i]; break; } } }
        /* The featured image belongs to this colour, so select it and show its set. */
        if(pick){ jhSetColorGallery(card, pick); return; }
        /* Otherwise select nothing: the featured image is not any variant's image, so
           auto-selecting one would hide it (Breeze Hipster's featured shot is on no variant).
           _jhGallery stays unset, which is what makes hover cycle the product's own images. */
        /* already in the server-rendered state (product images, first one shown) - only touch the DOM if not */
        card._jhGallery = null;
        var imgs = card.querySelectorAll('.jh-pc__img');
        if(card.querySelectorAll('.jh-pc__zone').length !== (imgs.length > 1 ? imgs.length : 0)) jhBuildZones(card, imgs.length);
        imgs.forEach(function(img){ var on = parseInt(img.dataset.jhPcImgIdx,10) === 0; if(img.classList.contains('is-active') !== on) img.classList.toggle('is-active', on); });
        card.querySelectorAll('[data-jh-pc-vimg].is-shown').forEach(function(l){ l.classList.remove('is-shown'); });
      });
    }
    function jhApplyAll(){ jhApplyFilterColors(); jhDefaultSelect(); }
    /* record filter clicks for recency (capture phase, before the facet form reloads/AJAX-updates) */
    document.addEventListener('change', function(e){ if(jhIsColorFilter(e.target) && e.target.checked){ jhPushRec(jhColorOf(e.target)); } }, true);
    jhApplyAll();
    /* re-apply after Shopify facets AJAX-swap the grid. Our own updates only touch a card once (the
       filter/default helpers no-op when the right swatch is already selected), so no mutation loop. */
    try {
      var jhGrid = document.querySelector('#product-grid, .product-grid, [id*="ProductGrid"], .collection__products, .jh-collection, main') || document.body;
      var jhT=null, jhObs=new MutationObserver(function(){ clearTimeout(jhT); jhT=setTimeout(jhApplyAll, 120); });
      jhObs.observe(jhGrid, { childList:true, subtree:true });
    } catch(e){}
  })();

/* Deferred card images (img[data-kr-defer], rendered for carousel cards after the 4th and grid cards after the 8th):
   src/srcset are applied after the window load event, per section, once that section is within one screen of the
   viewport - so these photos never compete with the hero / product image during load. Cards inserted later
   (filters, pagination, quick view) are hydrated immediately. */
(function () {
  function hyd(img) {
    if (img.hasAttribute('data-kr-srcset')) { img.setAttribute('srcset', img.getAttribute('data-kr-srcset')); img.removeAttribute('data-kr-srcset'); }
    if (img.hasAttribute('data-kr-src')) { img.setAttribute('src', img.getAttribute('data-kr-src')); img.removeAttribute('data-kr-src'); }
    img.removeAttribute('data-kr-defer');
  }
  var started = false;
  function start() {
    if (started) return; started = true;
    var imgs = [].slice.call(document.querySelectorAll('img[data-kr-defer]'));
    if (!('IntersectionObserver' in window)) { imgs.forEach(hyd); }
    else {
      var groups = new Map();
      imgs.forEach(function (i) { var g = i.closest('.shopify-section') || i.parentElement; if (!groups.has(g)) groups.set(g, []); groups.get(g).push(i); });
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (!e.isIntersecting) return; io.unobserve(e.target); (groups.get(e.target) || []).forEach(hyd); });
      }, { rootMargin: '100% 0px' });
      groups.forEach(function (_, g) { io.observe(g); });
    }
    if (window.MutationObserver) {
      new MutationObserver(function (ms) {
        ms.forEach(function (m) {
          m.addedNodes.forEach(function (n) {
            if (n.nodeType !== 1) return;
            if (n.matches && n.matches('img[data-kr-defer]')) hyd(n);
            if (n.querySelectorAll) n.querySelectorAll('img[data-kr-defer]').forEach(hyd);
          });
        });
      }).observe(document.body, { childList: true, subtree: true });
    }
  }
  /* Start at whichever comes first: the page's high-priority (LCP) image(s) finished, the load event (late on this
     store - third-party scripts), or the visitor scrolling / touching. Until then these photos would only share
     bandwidth with the LCP image: on slow connections Chrome's lazy-load distance is ~2500px. */
  if (document.readyState === 'complete') { start(); return; }
  window.addEventListener('load', start, { once: true });
  ['scroll', 'touchstart', 'pointerdown', 'keydown'].forEach(function (ev) { window.addEventListener(ev, start, { once: true, passive: true, capture: true }); });
  function watchLcp() {
    var hi = [].slice.call(document.querySelectorAll('img[fetchpriority="high"]'));
    if (!hi.length) return;
    var left = hi.length;
    function one() { if (--left <= 0) setTimeout(start, 0); }
    hi.forEach(function (i) { if (i.complete) one(); else { i.addEventListener('load', one, { once: true }); i.addEventListener('error', one, { once: true }); } });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchLcp, { once: true }); else watchLcp();
})();
